import { render, staticRenderFns } from "./PayslipDetail.vue?vue&type=template&id=bb4a446a"
import script from "../../controllers/payslip/payslip-detail.js?vue&type=script&lang=js&external"
export * from "../../controllers/payslip/payslip-detail.js?vue&type=script&lang=js&external"
import style0 from "./PayslipDetail.vue?vue&type=style&index=0&id=bb4a446a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports